/* DEADBOOY theme layer: hero countdown */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

  // load only the video that fits this screen, then fade it in over the poster
  function initVideo(root) {
    if (reduce) return;
    var videos = root.querySelectorAll('[data-db-video]');
    if (!videos.length) return;
    var isMobile = mobileQuery && mobileQuery.matches;
    var hasMobile = root.querySelector('[data-db-video="mobile"]');
    var pick = null;
    videos.forEach(function (v) {
      var kind = v.getAttribute('data-db-video');
      if (kind === 'all') pick = pick || v;
      if (kind === 'desktop' && (!isMobile || !hasMobile)) pick = v;
      if (kind === 'mobile' && isMobile) pick = v;
    });
    videos.forEach(function (v) { if (v !== pick) v.remove(); });
    if (!pick) return;
    pick.querySelectorAll('source[data-src]').forEach(function (s) {
      s.src = s.getAttribute('data-src');
    });
    function show() { pick.classList.add('is-playing'); }
    pick.addEventListener('playing', show, { once: true });
    pick.load();
    var p = pick.play();
    if (p && p.then) p.then(show).catch(function () {});
  }

  function initHero(root) {
    if (!root || root.dataset.dbReady) return;
    root.dataset.dbReady = '1';

    initVideo(root);

    var target = Date.parse(root.getAttribute('data-target') || '');
    if (isNaN(target)) return;

    var out = root.querySelector('[data-count]');
    var label = root.querySelector('[data-count-label]');
    var liveText = root.getAttribute('data-live-label') || '';
    var timer;

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        root.classList.add('is-live');
        if (label && liveText) label.textContent = liveText;
        clearInterval(timer);
        return;
      }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400);
      if (out) {
        out.textContent = d + 'd ' + pad(Math.floor((s % 86400) / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      }
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-db-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
